import * as types from "./types";

const fetchTipStart = () => ({
   type: types.FETCH_TIP_START,
});
const fetchTipCompleted = (data) => ({
   type: types.FETCH_TIP_COMPLETED,
   payload: data,
});
const fetchTipFailed = () => ({
   type: types.FETCH_TIP_FAILED,
});

const checkTipLimitStart = () => ({
   type: types.CHECK_TIP_LIMIT_START,
});
const checkTipLimitCompleted = (data) => ({
   type: types.CHECK_TIP_LIMIT_COMPLETED,
   payload: data,
});
const checkTipLimitFailed = (data) => ({
   type: types.CHECK_TIP_LIMIT_FAILED,
   payload: data,
});

const setModalState = (data) => ({
   type: types.SET_MODAL_STATE,
   payload: data,
});
const setTipDataState = (data) => ({
   type: types.SET_TIP_DATA_STATE,
   payload: data,
});


export {
   fetchTipStart,
   fetchTipCompleted,
   fetchTipFailed,

   checkTipLimitStart,
   checkTipLimitCompleted,
   checkTipLimitFailed,

   setModalState,
   setTipDataState,
};
